/**
 * Misell Stable (Optimized)
 * - Visual order: Color top / Size bottom (CSS order only)
 * - Listing pages: Replace "カートに入れる" -> "サイズを確認する"
 * - Listing pages: Redirect purchase actions to product page
 * - Listing pages: Block /cart/add(.js) as safety net
 * - Never block option UI clicks
 * - Robust but lighter: no listener duplication, scoped observer, reduced polling
 */
(function () {
  // ----------------------------------------------------------
  // Double-load guard
  // ----------------------------------------------------------
  if (window.__misellStableLoaded) return;
  window.__misellStableLoaded = true;

  // ==========================================================
  // CSS
  // ==========================================================
  function ensureCSS() {
  if (document.getElementById('misell-stable-style')) return;

  var st = document.createElement('style');
  st.id = 'misell-stable-style';

  st.textContent = [
    '.toast-guard{position:fixed;left:50%;bottom:18px;transform:translateX(-50%);z-index:999999;background:#111;color:#fff;padding:10px 12px;border-radius:10px;font-size:13px;line-height:1.4;max-width:min(92vw,520px);box-shadow:0 10px 20px rgba(0,0,0,.25);}',

    // Visual reorder (no DOM move)
    '[data-js-product-options].misell-order-col{display:flex;flex-direction:column;gap:0;}',
    '[data-js-product-options].misell-order-col [data-section-container].misell-opt-color{order:10;}',
    '[data-js-product-options].misell-order-col [data-section-container].misell-opt-size{order:20;}',
    '[data-js-product-options].misell-order-col [data-section-container]{order:30;}',

    // Listing page button design
'.misell-listing-detail-btn{border:1px solid #9B7A67!important;background:#ffffff!important;color:#6E5040!important;border-radius:6px!important;min-height:44px!important;padding:0 18px!important;font-size:14px!important;font-weight:500!important;letter-spacing:.04em!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;box-shadow:0 2px 6px rgba(110,80,64,.06)!important;transition:all .2s ease!important;}',
'.misell-listing-detail-btn:hover{background:#6E5040!important;color:#ffffff!important;border-color:#6E5040!important;box-shadow:0 4px 10px rgba(110,80,64,.14)!important;transform:translateY(-1px);}',
'.misell-listing-detail-btn .btn__text{color:inherit!important;}',
'@media screen and (max-width:768px){.misell-listing-detail-btn{min-height:44px!important;border-radius:6px!important;font-size:13px!important;padding:0 14px!important;}}'
  ].join('\n');

  document.head.appendChild(st);
}

  function toast(msg, ms) {
    ms = ms || 1800;
    var el = document.createElement('div');
    el.className = 'toast-guard';
    el.textContent = msg;
    document.body.appendChild(el);
    setTimeout(function () { try { el.remove(); } catch (e) {} }, ms);
  }

  // ==========================================================
// Page type
// ==========================================================
function isProductPage() {
  return (location.pathname || '').indexOf('/products/') === 0;
}

function isListingLikePage() {
  var p = location.pathname || '';

  return (
    p === '/' ||
    p === '/collections/pupakiotti'
  );
}
// ==========================================================
// Helpers
// ==========================================================
  function isVisible(el) {
    if (!el) return false;
    if (el.offsetParent !== null) return true;
    return el.getClientRects && el.getClientRects().length > 0;
  }

  function norm(s) { return (s || '').replace(/[：:\s]/g, '').toLowerCase(); }
  function isColorName(s) { return /(カラー|色|color|colour)/i.test(s || ''); }
  function isSizeName(s) { return /(サイズ|size)/i.test(s || ''); }

  // Never block option UI interaction
  function isInsideOptionsUI(target) {
    if (!target || !target.closest) return false;
    return !!target.closest(
      '[data-js-product-options],' +
      '.product-options,' +
      '.product-options__section,' +
      '[data-section-container],' +
      '[data-js-option-value],' +
      '.product-options__value,' +
      '.select,' +
      '.select__dropdown'
    );
  }

  function findSectionContainerByKind(root, kind) {
    if (!root) return null;
    var containers = Array.from(root.querySelectorAll('[data-section-container]'));
    for (var i = 0; i < containers.length; i++) {
      var c = containers[i];

      // 1) data-property
      var sec = c.querySelector('.product-options__section[data-property]');
      if (sec) {
        var prop = sec.getAttribute('data-property') || '';
        if (kind === 'color' && isColorName(prop)) return c;
        if (kind === 'size' && isSizeName(prop)) return c;
      }

      // 2) label text
      var label = c.querySelector('label');
      var t = label ? norm(label.textContent) : '';
      if (kind === 'color' && isColorName(t)) return c;
      if (kind === 'size' && isSizeName(t)) return c;
    }
    return null;
  }

  function applyVisualOrder(root) {
    if (!root) return false;

    // If already processed and still valid, skip quickly
    if (root.classList.contains('misell-order-col')) return true;

    var colorC = findSectionContainerByKind(root, 'color');
    var sizeC  = findSectionContainerByKind(root, 'size');
    if (!colorC || !sizeC) return false;

    root.classList.add('misell-order-col');
    colorC.classList.add('misell-opt-color');
    sizeC.classList.add('misell-opt-size');
    return true;
  }

  // ==========================================================
  // Reorder: Product + Listing
  // ==========================================================
  function reorderEverywhere() {
    // only unprocessed blocks to reduce cost
    var wraps = Array.from(document.querySelectorAll('[data-js-product-options]:not(.misell-order-col)'));
    wraps.forEach(function (w) { applyVisualOrder(w); });
  }

  // ==========================================================
  // Listing pages text replace
  // ==========================================================
  var TEXT_FROM = 'カートに入れる';

var TEXT_TO =
  (location.pathname || '') === '/collections/pupakiotti'
    ? 'この商品を見る'
    : 'サイズを確認する';

  function changeListingAddToCartText() {
  if (!isListingLikePage()) return;

  // spans
  var spans = Array.from(document.querySelectorAll('span.btn__text'));

  spans.forEach(function (sp) {
    if (!isVisible(sp)) return;

    var t = (sp.textContent || '').replace(/\s+/g, ' ').trim();

    // If marked but text was reverted, re-apply
    if (sp.dataset.misellReplaced === '1') {
      if (t === TEXT_FROM) sp.textContent = TEXT_TO;

      var existingBtn = sp.closest('button, a, [role="button"], .btn');
      if (existingBtn) existingBtn.classList.add('misell-listing-detail-btn');

      return;
    }

    if (t === TEXT_FROM) {
      sp.textContent = TEXT_TO;
      sp.dataset.misellReplaced = '1';

      var btn = sp.closest('button, a, [role="button"], .btn');
      if (btn) btn.classList.add('misell-listing-detail-btn');
    }
  });

  // inputs
  var inputs = Array.from(document.querySelectorAll('input[type="submit"], input[type="button"]'));

  inputs.forEach(function (ip) {
    if (!isVisible(ip)) return;
    if (ip.disabled) return;

    var v = (ip.value || '').trim();

    if (ip.dataset.misellReplaced === '1') {
      if (v === TEXT_FROM) ip.value = TEXT_TO;
      ip.classList.add('misell-listing-detail-btn');
      return;
    }

    if (v === TEXT_FROM) {
      ip.value = TEXT_TO;
      ip.dataset.misellReplaced = '1';
      ip.classList.add('misell-listing-detail-btn');
    }
  });
}
  

  // ==========================================================
  // Listing redirect guard（purchase buttons only）
  // ==========================================================
  var lastTarget = null;
  var redirectLockUntil = 0;

  function nearestProductsLink(t) {
    if (!t) return '';
    var node = t;

    for (var i = 0; i < 10 && node; i++) {
      if (node.matches && node.matches('a[href*="/products/"]')) return node.href;
      if (node.querySelector) {
        var near = node.querySelector('a[href*="/products/"]');
        if (near) return near.href;
      }
      node = node.parentElement;
    }

    var first = document.querySelector('a[href*="/products/"]');
    return first ? first.href : '';
  }

  function isPurchaseButton(el) {
    if (!el) return false;

    if (el.closest && el.closest('[data-js-product-button-add-to-cart]')) return true;
    if (el.hasAttribute && el.hasAttribute('data-js-product-button-add-to-cart')) return true;

    var txt = (el.innerText || el.textContent || '').replace(/\s+/g, ' ').trim();
    if (txt === TEXT_TO) return true;
    if (txt === TEXT_FROM) return true;
    if (txt.indexOf('今すぐ購入') !== -1) return true;
    if (txt.indexOf('購入する') !== -1) return true;

    var id = (el.id || '').toLowerCase();
    var cls = (el.className || '').toString().toLowerCase();
    if (cls.includes('add-to-cart')) return true;
    if (cls.includes('add') && cls.includes('cart')) return true;
    if (id.includes('add') && id.includes('cart')) return true;

    return false;
  }

  function redirectToSameProduct(fromEl) {
    var now = Date.now();
    if (now < redirectLockUntil) return;
    redirectLockUntil = now + 900;

    var href = nearestProductsLink(fromEl) || nearestProductsLink(lastTarget);
    toast('商品ページでカラー・サイズを選んでください。');

    if (href) {
      setTimeout(function () {
        try {
          var url = href.indexOf('?') >= 0 ? (href + '&from=listing') : (href + '?from=listing');
          location.href = url;
        } catch (e) {}
      }, 200);
    }
  }

  function attachListingRedirectAndGuard() {
    if (!isListingLikePage()) return;

    // ✅ Never add listeners more than once
    if (window.__misellListingListenersAdded) return;
    window.__misellListingListenersAdded = true;

    // track last target (capture)
    ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach(function (evName) {
      document.addEventListener(evName, function (e) { lastTarget = e.target; }, true);
    });

    // click guard (capture)
    document.addEventListener('click', function (e) {
      if (isInsideOptionsUI(e.target)) return;

      var el = e.target.closest('button, a, input, [role="button"]');
      if (!el) return;
      if (!isPurchaseButton(el)) return;

      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

      redirectToSameProduct(el);
    }, true);

    // submit guard (capture)
    document.addEventListener('submit', function (e) {
      if (isInsideOptionsUI(e.target)) return;

      var form = e.target;
      if (!form) return;
      var action = (form.getAttribute('action') || '');
      if (action.indexOf('/cart/add') === -1) return;

      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

      redirectToSameProduct(form);
    }, true);

    // safety net: fetch guard (listing only)
    if (window.fetch && !window.__misellFetchListingHookedStable) {
      window.__misellFetchListingHookedStable = true;
      var origFetch = window.fetch;
      window.fetch = function (input, init) {
        try {
          var url = (typeof input === 'string') ? input : (input && input.url) ? input.url : '';
          if (isListingLikePage() && url && (url.indexOf('/cart/add.js') !== -1 || url.indexOf('/cart/add') !== -1)) {
            redirectToSameProduct(lastTarget);
            return Promise.resolve(new Response('blocked', { status: 409 }));
          }
        } catch (e) {}
        return origFetch.apply(this, arguments);
      };
    }

    // safety net: XHR guard (listing only)
    if (window.XMLHttpRequest && !window.__misellXHRListingHookedStable) {
      window.__misellXHRListingHookedStable = true;
      var XHR = window.XMLHttpRequest;
      var origOpen = XHR.prototype.open;
      var origSend = XHR.prototype.send;

      XHR.prototype.open = function (method, url) {
        this.__misell_url = url;
        return origOpen.apply(this, arguments);
      };

      XHR.prototype.send = function () {
        try {
          var url = this.__misell_url || '';
          if (isListingLikePage() && url && (url.indexOf('/cart/add.js') !== -1 || url.indexOf('/cart/add') !== -1)) {
            redirectToSameProduct(lastTarget);
            try { this.abort(); } catch (e) {}
            return;
          }
        } catch (e2) {}
        return origSend.apply(this, arguments);
      };
    }
  }

  // ==========================================================
  // INIT
  // ==========================================================
  function runAllSafe() {
    try {
      ensureCSS();

      // Visual order (product + listing)
      reorderEverywhere();

      // Listing-only behaviors
      if (isListingLikePage()) {
        changeListingAddToCartText();
        attachListingRedirectAndGuard();
      }
    } catch (e) {
      try { console.warn('[misell] init error:', e); } catch (_) {}
    }
  }

  function init() {
    runAllSafe();

    // light follow-up: 3 seconds (0.5s * 6)
    var n = 0;
    var timer = setInterval(function () {
      n++;
      runAllSafe();
      if (n >= 6) clearInterval(timer);
    }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Section load: re-run once (✅ do NOT reset guards)
  document.addEventListener('shopify:section:load', function () {
    runAllSafe();
  });

  // Mutation observer: scoped & debounced
  if (window.MutationObserver) {
    var target = document.querySelector('#MainContent') || document.querySelector('main') || document.body;

    var mo = new MutationObserver(function () {
      clearTimeout(window.__misellStableTimer);
      window.__misellStableTimer = setTimeout(function () {
        runAllSafe();
      }, 250);
    });

    mo.observe(target, { childList: true, subtree: true });
  }
})();

/* ==========================================================
 * Complementary products: inline option selectors + add to cart
 * ========================================================== */
(function () {
  function uniqueValues(list) {
    var seen = Object.create(null);
    var out = [];
    list.forEach(function (value) {
      if (!seen[value]) {
        seen[value] = true;
        out.push(value);
      }
    });
    return out;
  }

  function initComplementaryForms(root) {
    root = root || document;

    var forms = root.querySelectorAll
      ? root.querySelectorAll('.js-complementary-product-form:not([data-complementary-initialized])')
      : [];

    Array.prototype.forEach.call(forms, function (form) {
      form.setAttribute('data-complementary-initialized', 'true');
      var variantsNode = form.querySelector('.js-complementary-variants-json');
      var hiddenInput = form.querySelector('.js-complementary-variant-id');
      var button = form.querySelector('.js-complementary-add-to-cart');
      var message = form.querySelector('.js-complementary-message');
      var selects = Array.prototype.slice.call(form.querySelectorAll('.js-complementary-option'));
      var variants = [];
     
      function getCartPreset() {
        var rootNode = form.closest('.js-cart-complementary-root');

        if (!rootNode) {
          return {
            size: '',
            color: ''
          };
        }

        return {
          size: (rootNode.getAttribute('data-harness-size') || '').trim(),
          color: (rootNode.getAttribute('data-harness-color') || '').trim()
        };
      }

      function getRecommendedLeashSize(harnessSize) {
        var size = String(harnessSize || '').trim().toUpperCase();

        if (size === '2XS' || size === 'XS-S' || size === 'M-L') {
          return '12mm';
        }

        if (size === 'XL-XXL' || size === '3XL-4XL') {
          return '20mm';
        }

        return '';
      }

      function getRecommendedMessage() {
        var preset = getCartPreset();
        var recommended = getRecommendedLeashSize(preset.size);

        if (recommended) {
          return '同じカラーの【' + recommended + '】リーシュがおすすめです。';
        }

        return '同じカラーのリーシュがおすすめです。';
      }

      if (!variantsNode || !hiddenInput || !button) return;

      try {
        variants = JSON.parse(variantsNode.textContent || '[]');
      } catch (e) {
        console.warn('[misell complementary] variants json parse error', e);
        return;
      }
     
      if (!variants.length) return;

      function getSelectedValues() {
        return selects.map(function (select) {
          return select.value;
        });
      }

      function findVariantBySelections(values) {
        return variants.find(function (variant) {
          return variant.options.every(function (optionValue, index) {
            return optionValue === values[index];
          });
        }) || null;
      }

      function matchingVariants(ignoreIndex) {
        var values = getSelectedValues();

        return variants.filter(function (variant) {
          if (!variant.available) return false;

          return values.every(function (value, index) {
            if (index === ignoreIndex) return true;
            return !value || variant.options[index] === value;
          });
        });
      }

      function rebuildSelect(select) {
        var optionIndex = parseInt(select.getAttribute('data-option-position'), 10) - 1;
        var currentValue = select.value;
        var currentOptions = Array.prototype.map.call(select.options, function (opt) {
          return opt.value;
        });

        var availableValues = uniqueValues(
          matchingVariants(optionIndex).map(function (variant) {
            return variant.options[optionIndex];
          })
        );

        if (!availableValues.length) {
          availableValues = uniqueValues(
            variants
              .filter(function (variant) {
                return variant.options[optionIndex] !== undefined;
              })
              .map(function (variant) {
                return variant.options[optionIndex];
              })
          );
        }

        var changed = availableValues.join('||') !== currentOptions.join('||');

        if (changed) {
          select.innerHTML = '';
          availableValues.forEach(function (value) {
            var opt = document.createElement('option');
            opt.value = value;
            opt.textContent = value;
            select.appendChild(opt);
          });
        }

        if (availableValues.indexOf(currentValue) !== -1) {
          select.value = currentValue;
        } else if (availableValues.length) {
          select.value = availableValues[0];
          changed = true;
        }

        return changed;
      }

      var productCard = form.closest('.product-featured');
      var priceBox = productCard ? productCard.querySelector('.js-complementary-price') : null;
      
      function formatMoneySafe(value) {
        if (window.Shopify && typeof Shopify.formatMoney === 'function') {
          var moneyFormat = (window.theme && theme.moneyFormat) ? theme.moneyFormat : undefined;
          return Shopify.formatMoney(value, moneyFormat);
        }
        return '¥' + Number(value || 0).toLocaleString('ja-JP');
      }

      function renderRangePrice() {
        if (!priceBox) return;

        var prices = variants
          .map(function (variant) { return variant.price; })
          .filter(function (price) { return typeof price === 'number'; });

        if (!prices.length) return;

        var min = Math.min.apply(null, prices);
        var max = Math.max.apply(null, prices);

        if (min !== max) {
          priceBox.innerHTML = '<span>' + formatMoneySafe(min) + '～' + formatMoneySafe(max) + '</span>';
        } else {
          priceBox.innerHTML = '<span>' + formatMoneySafe(min) + '</span>';
        }
      }

      function updateState() {
        for (var i = 0; i < 3; i++) {
          var changed = false;
          selects.forEach(function (select) {
            if (rebuildSelect(select)) changed = true;
          });
          if (!changed) break;
        }

        var values = getSelectedValues();
        var variant = findVariantBySelections(values);

        if (!variant) {
          hiddenInput.value = '';
          button.disabled = true;
          button.setAttribute('disabled', 'disabled');
          button.setAttribute('data-button-status', 'sold-out');
          if (message) message.textContent = 'この組み合わせは選べません。';
          renderRangePrice();
          return;
        }

        hiddenInput.value = variant.id;
       
        if (priceBox) {
          priceBox.innerHTML = '<span>' + formatMoneySafe(variant.price) + '</span>';
        }

        if (variant.available) {
          button.disabled = false;
          button.removeAttribute('disabled');
          button.removeAttribute('data-button-status');
          if (message) message.textContent = getRecommendedMessage();
        } else {
          button.disabled = true;
          button.setAttribute('disabled', 'disabled');
          button.setAttribute('data-button-status', 'sold-out');
          if (message) message.textContent = '在庫切れの組み合わせです。';
        }
      }

      selects.forEach(function (select) {
        select.addEventListener('change', updateState);
      });

      updateState();
    });
  }

  window.MisellComplementaryInlineInit = initComplementaryForms;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initComplementaryForms(document);
    });
  } else {
    initComplementaryForms(document);
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
        if (!node || node.nodeType !== 1) return;

        if (node.matches && node.matches('.js-complementary-product-form')) {
          initComplementaryForms(node.parentNode || node);
        } else if (node.querySelector && node.querySelector('.js-complementary-product-form')) {
          initComplementaryForms(node);
        }
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
/* ==========================================================
 * Product size guide popup hard intercept
 * - Products with #bs-size-guide-anchor: scroll
 * - Products without anchor: default popup remains
 * - Delivery/Return and Message remain unchanged
 * ========================================================== */
(function () {
  function isProductPage() {
    return (location.pathname || '').indexOf('/products/') === 0;
  }

  function getFixedHeaderHeight() {
    var header =
      document.querySelector('.header') ||
      document.querySelector('[data-section-type="header"]') ||
      document.querySelector('header');

    if (!header) return 0;

    var style = window.getComputedStyle(header);
    var position = style.position;

    if (position === 'fixed' || position === 'sticky') {
      return header.offsetHeight || 0;
    }

    return 0;
  }

  function scrollToSizeGuide() {
    var target = document.getElementById('bs-size-guide-anchor');
    if (!target) return false;

    var offset = getFixedHeaderHeight() + 16;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });

    return true;
  }

  function interceptSizeGuide(e) {
    if (!isProductPage()) return;

    var button = e.target && e.target.closest
      ? e.target.closest('[data-js-popup-button="size-guide"]')
      : null;

    if (!button) return;

    var target = document.getElementById('bs-size-guide-anchor');

    /* アンカーがない商品は、今まで通りポップアップ */
    if (!target) return;

    e.preventDefault();
    e.stopPropagation();

    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }

    scrollToSizeGuide();
  }

  window.addEventListener('click', interceptSizeGuide, true);
  window.addEventListener('touchend', interceptSizeGuide, true);
})();